import { authRoles } from 'app/Core/Funcionalidade/Auth';
import CriarEmpresa from './CriarEmpresa';
import CriarEmpresaTeste from './CriarEmpresaTeste';

export const CriarEmpresaConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.onlyGuest,
    routes: [
        {
            path: '/solicitar-teste',
            component: CriarEmpresaTeste
        },
        {
            path: '/solicitar-empresa',
            component: CriarEmpresa
        }
    ]
};

